import React from "react";
import { Link } from "react-router-dom";

function TreeSubscriptionSuccessful() {
  return (
    <div className="main-wrapper d-flex align-items-center justify-content-center vh-100" style={{
      background: 'linear-gradient(135deg, #f4f7f5 0%, #e8f0ea 100%)',
      fontFamily: "'DM Sans', sans-serif",
      padding: '1rem'
    }}>
      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(16px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-6px); }
        }
        @keyframes popIn {
          0% { transform: scale(0); opacity: 0; }
          60% { transform: scale(1.1); opacity: 1; }
          100% { transform: scale(1); }
        }
      `}</style>

      <div className="card" style={{
        maxWidth: '460px',
        width: '100%',
        background: '#ffffff',
        borderRadius: '24px',
        overflow: 'hidden',
        boxShadow: '0 20px 40px -12px rgba(0, 0, 0, 0.15)',
        animation: 'fadeInUp 0.5s ease-out',
        textAlign: 'center'
      }}>

        {/* Header — same gradient language as the subscription banner */}
        <div style={{
          background: 'linear-gradient(135deg, #184A2C 0%, #0f3620 100%)',
          padding: '2rem 1.5rem 1.5rem'
        }}>
          <div style={{
            width: '76px',
            height: '76px',
            margin: '0 auto 1rem',
            background: 'rgba(255,255,255,0.15)',
            border: '1px solid rgba(255,255,255,0.2)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            animation: 'float 3s ease-in-out infinite'
          }}>
            <div style={{
              width: '52px',
              height: '52px',
              background: '#75B437',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              animation: 'popIn 0.5s ease-out 0.15s both'
            }}>
              <i className="fas fa-check" style={{ fontSize: '22px', color: '#ffffff' }}></i>
            </div>
          </div>

          <p style={{
            color: 'rgba(255,255,255,0.6)',
            fontSize: '0.7rem',
            fontWeight: 600,
            letterSpacing: '0.12em',
            textTransform: 'uppercase',
            margin: '0 0 0.4rem'
          }}>
            Subscription Confirmed
          </p>

          <h3 style={{
            color: '#ffffff',
            margin: 0,
            fontSize: '1.3rem',
            fontWeight: 600
          }}>
            Payment Successful 🎉
          </h3>
        </div>

        {/* Body */}
        <div style={{ padding: '1.75rem 1.75rem 1.5rem' }}>

          <p style={{
            color: '#5c6b62',
            fontSize: '0.9rem',
            lineHeight: 1.6,
            margin: '0 0 1.5rem'
          }}>
            Thank you for subscribing! Your payment has been processed successfully.
            You can now log in to enjoy full access to your family tree.
          </p>

          {/* Info strip, same tone/box style used elsewhere */}
          <div style={{
            background: '#f8fcf9',
            border: '1px solid #e5ede8',
            borderRadius: '12px',
            padding: '0.75rem',
            marginBottom: '1.5rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px'
          }}>
            <i className="fas fa-tree" style={{ color: '#75B437', fontSize: '0.9rem' }}></i>
            <p style={{ margin: 0, color: '#184A2C', fontSize: '0.8rem', fontWeight: 600 }}>
              A confirmation receipt has been sent to you.
            </p>
          </div>

          {/* CTA */}
          {/*<Link
            to="/"
            style={{
              display: 'block',
              width: '100%',
              padding: '0.75rem',
              borderRadius: '40px',
              background: '#75B437',
              color: '#ffffff',
              fontWeight: 600,
              fontSize: '0.9rem',
              textDecoration: 'none',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => e.target.style.background = '#184A2C'}
            onMouseLeave={(e) => e.target.style.background = '#75B437'}
          >
            <i className="fas fa-sign-in-alt me-2"></i>
            Log In to Continue
          </Link>*/}

        </div>

        {/* Footer, consistent with the other pages */}
        <div style={{
          borderTop: '1px solid #e5ede8',
          padding: '0.75rem',
          background: '#fafdfb'
        }}>
          <p style={{ fontSize: '0.7rem', color: '#8aa899', margin: 0 }}>
            <i className="fas fa-headset me-1"></i> Need help? Contact support@oret.africa
          </p>
        </div>

      </div>
    </div>
  );
}

export default TreeSubscriptionSuccessful;